import { addChatFocused } from './chat-focused/chat-focused';
import { addChatReady } from './chat-ready/chat-ready';
import { addDialNumberEvent } from './dial-number/dial-number';
import { addErrorEvent } from './error/error';
import { addExitChatEvent } from './exit-chat/exit-chat';
import { addGetPageIdEvent } from './get-page-id/get-page-id';
import { addKeepAliveEvent } from './keep-alive/keep-alive';
import { addNavigateEvent } from './navigate/navigate';
import { addSetWChatSessionIdEvent } from './set-wchat-session-id/set-wchat-session-id';
export var addEventListeners = function addEventListeners() {
  addChatFocused();
  addChatReady();
  addDialNumberEvent();
  addErrorEvent();
  addExitChatEvent();
  addGetPageIdEvent();
  addKeepAliveEvent();
  addNavigateEvent();
  addSetWChatSessionIdEvent();
};